import CrefoUI from './crefo-ui.bundle'

const UIPlugin = {
    install(Vue, options) {
        Vue.mixin({
            created: function() {
                for (let key in CrefoUI) {
                    if (typeof CrefoUI[key].init === 'function') {
                        CrefoUI[key].init()
                    }
                }
            },
            updated: function() {
                for (let key in CrefoUI) {
                    if (typeof CrefoUI[key].init === 'function') {
                        CrefoUI[key].init()
                    }
                    if (typeof CrefoUI[key].update === 'function') {
                        CrefoUI[key].update()
                    }
                }
            }
        })
    }
}

export default UIPlugin
